// M4-A2/A3 — inizializzazione shell mobile (SOLO runtime Capacitor). Additivo: nessun effetto sul web.
// Non tocca auth/Stripe/deep-link/push/file. Import dinamici: i plugin nativi non entrano nel path web.
import { initMobileBackButton } from "@/mobileBackButton";
import { initMobileExternalLinks } from "@/mobileExternalLinks";
import { initMobileDeepLinks } from "@/mobileDeepLinks";

export async function initMobileShell() {
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return;
  try {
    const { StatusBar } = await import("@capacitor/status-bar");
    // WebView sotto la status bar (no sovrapposizioni). Nessun colore forzato: gestione di sistema.
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (e) { /* status-bar non disponibile: non bloccante */ }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch (e) { /* splash non disponibile: non bloccante */ }
  // M4-A3: back button Android + intercettazione link esterni.
  await initMobileBackButton();
  await initMobileExternalLinks();
  // M4-A5.2: Universal Links (iOS) — instrada gli URL tricomas.it verso route interne.
  await initMobileDeepLinks();
}
